type IconSize = 'sm' | 'md';

type Props = {
  size?: IconSize;
  onClick?: () => void;
};

const fill = '#00d091';

const sizeMap: Record<IconSize, { width: string; height: string }> = {
  sm: {
    width: '24',
    height: '24',
  },
  md: {
    width: '50',
    height: '50',
  },
};

export const ClearChatIcon = ({ size = 'md', onClick }: Props) => {
  const { width, height } = sizeMap[size];

  return (
    <svg
      onClick={onClick ? onClick : () => null}
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"
        fill={fill}
      />
    </svg>
  );
};
